import React, { Component } from 'react';
import utilFunction from '../../../containers/function'
import strings from '../../locales/';
import SpiderChart from '../graphs/crossfilterGraphs/spiderChart';

const BehaviorIndicatorsGraph = (props) => (
  <div className="behavior-indicators-graph dc-chart-parent">
    <SpiderChart 
      id={"behavior-indicators-graph-component"+((props.extraId)?props.extraId:"")} 
      crossfilerData={utilFunction.generateCrossfilter([props.data.indicators.reduce(
        function(valorAnterior, valorActual, indice, vector){
          for(var i=0; i<valorActual.items.length; i++) {
            if(valorActual.items[i].type=="grade") {
              valorAnterior[valorActual.name] = valorActual.items[i].value;
            }
          }
          return valorAnterior;
        },{behaviorGrade:props.data.behaviorGrade}
      )])}
      dimension={{
        formatFunction:[],
        name:"date",
        originalName:"date",
        reduceFunction:{type:"DISCRETE_GROUP",typeof:"DATE_TIME",parameters:{categoriesParser:[],categories:[[{value:"ALL",operator:"=="}]],labels:["ALL"]}},
      }}
      metrics={props.data.indicators.map(function(item, i){
        return {
          config:{},
          filter: [],
          formatFunction: [],
          metric: item.name,
          name: (props.config[item.name])?props.config[item.name].name:item.name,
          reduceFunction: {type: "FIRST_VALUE"},
          type: "FIRST_VALUE"
        };
      }).concat([
        {
          config:{show:false,forAreaColor:true},
          filter: [],
          formatFunction: [],
          metric: "behaviorGrade",
          name: "Nota",
          reduceFunction: {type: "FIRST_VALUE"},
          type: "FIRST_VALUE"
        }
      ])} 
      config={{
        "tooltip":{
          "valuesConfig":[
            {"identifier":"label","valueFormat":{"type":"STRING","format":""},"wrapper":"<span>%v: </span>"},
            {"identifier":"value","colorRange":[
              {"color":"#CC5660","range":[{"value":props.graphColorRange.higherRisk[1],"operator":"<"}]},
              {"color":"#F3B119","range":[{"value":props.graphColorRange.middleRisk[0],"operator":">="},{"value":props.graphColorRange.middleRisk[1],"operator":"<"}]},
              {"color":"#41C99F","range":[{"value":props.graphColorRange.outOfRisk[0],"operator":">="}]}
            ],"valueFormat":{"type":"NUMBER","format":".0f"},"wrapper":"<span style='font-weight:bold;'>%v</span>"}
          ]
        },
        "colorRange":[
          {"color":"#CC5660","range":[{"value":props.graphColorRange.higherRisk[1],"operator":"<"}]},
          {"color":"#F3B119","range":[{"value":props.graphColorRange.middleRisk[0],"operator":">="},{"value":props.graphColorRange.middleRisk[1],"operator":"<"}]},
          {"color":"#41C99F","range":[{"value":props.graphColorRange.outOfRisk[0],"operator":">="}]}
        ],
        "max":100
      }}
      dashboardId={"detail_behavior"}
    />
  </div>
);
  
export default BehaviorIndicatorsGraph;


// WEBPACK FOOTER //
// ./source/client/components/common/behavior/behaviorIndicatorsGraph.jsx